/* Largely copied from frontend/containers/corp/Login.tsx */
import SocialAuthCSS from 'react-scale/components/legacy-css/social-auth-css';
import Logo from 'design-system/ScaleLogo';
import LoginWithSAML from './LoginWithSAML';
import LoginWithGoogle from './LoginWithGoogle';
import { useQueryParam, StringParam } from 'use-query-params';
import { useEffect } from 'react';
import { useUser } from './useUser';

const DEFAULT_PATH = `/corp/genai-ops-hub`;
const LOGIN_PATH = `/corp/login`;

export default function LoginVite() {
  const [redirectPathInput] = useQueryParam('redirect_url', StringParam);
  const redirectPath = getSafeRedirectPath(redirectPathInput, DEFAULT_PATH, LOGIN_PATH);
  const redirectUrl = `${window.location.origin}${redirectPath}`;

  const { user } = useUser();

  useEffect(() => {
    if (user) {
      window.location.href = redirectUrl;
    }
  }, [user, redirectUrl]);

  return (
    <div className="wrapper">
      <div>
        <header>
          <Logo fill="white" />
          <span className="corp">CORP</span>
        </header>

        <div className="panel">
          <div>
            <LoginWithGoogle redirectUrl={redirectUrl} />
            <LoginWithSAML redirectUrl={redirectUrl} />
          </div>
        </div>
      </div>

      <SocialAuthCSS />
      <style jsx>{`
        .wrapper {
          width: 300px;
        }

        .corp {
          color: white;
          font-size: 11px;
          background: #4ab4c6;
          padding: 2px 4px;
          margin-left: 49px;
        }

        .link {
          color: white;
          text-align: center;
          display: block;
        }

        .panel {
          padding: 20px;
        }
      `}</style>
      <style jsx global>{`
        html,
        body {
          color: #4a4a4a;
          background: linear-gradient(
            90.13deg,
            #d1aad7 0.11%,
            #c88bc4 25.06%,
            #7b8fdd 50%,
            #86bff2 74.8%,
            #bbdef2 99.76%
          );
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 100%;
          padding: 0;
          margin: 0;
        }
        a {
          color: #000;
          text-decoration: none;
        }
      `}</style>
    </div>
  );
}

function getSafeRedirectPath(
  candidate: string | null | undefined,
  defaultPath: string,
  loginPath: string,
): string {
  if (!candidate) return defaultPath;
  try {
    const url = new URL(candidate, window.location.origin);
    if (url.origin !== window.location.origin) return defaultPath;
    if (candidate.startsWith('//')) return defaultPath;
    if (url.pathname.includes('..')) return defaultPath;
    if (url.pathname.includes(loginPath)) return defaultPath;
    return `${url.pathname}${url.search}${url.hash}` || defaultPath;
  } catch {
    return defaultPath;
  }
}
